import { Modal, Stack, Typography } from "@mui/material";
import React from "react";
import { BsXLg } from "react-icons/bs";
import { containerStyle, modalStyle, titleStyle } from "./wrapperStyle";

type PopupModelType = {
    children: React.ReactNode;
    handleClose: () => void;
    open: boolean;
    title: string;
    width?: any;
};

const PopupModelWrapper = (props: PopupModelType) => {
    const { children, handleClose, open, title, width } = props;

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            id={"popup-modal-" + title}
            sx={modalStyle}
        >
            <Stack
                sx={{ ...containerStyle, width: width || containerStyle.width }}
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography sx={titleStyle}>{title}</Typography>
                    <BsXLg
                        onClick={handleClose}
                        style={{ cursor: "pointer" }}
                        id={"popup-modal-button-" + title}
                    />
                </Stack>
                {children}
            </Stack>
        </Modal>
    );
};

export default PopupModelWrapper;
